import { createFileRoute } from '@tanstack/react-router';
import { CalendarView } from '../../../features/events/components/CalendarView.tsx';

export const Route = createFileRoute('/_authed/calendar/')({
  component: CalendarRoute,
});

function CalendarRoute() {
  return (
    <div className="flex-1 overflow-auto px-6 py-4">
      <CalendarView />
    </div>
  );
}
